// extracted by mini-css-extract-plugin
export default {"menu":"c-a_fg"};